import {Injectable} from '@angular/core';
import {ITrackingService} from './tracking.service.interface';
import {environment} from '../../../../environments/environment';
import {DateTimeUtils} from '../../projects/utils/date-time.utils';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../shared/services/my-http-client.service';

@Injectable()
export class TrackingService extends ITrackingService {

    public async createTrackingEvent(calledSection: string, calledTimestamp: Date): Promise<void> {
        await firstValueFrom(
            this.httpClient.post(
                `${this.serverAddress}/v1/partnerApp/tracking`,
                {
                    trackingInfo: [{
                        calledSection: calledSection,
                        calledTimestamp: DateTimeUtils.DateTimeToRestString(calledTimestamp)
                    }]
                }
            )
        );
    }
}

